import flatMap from 'lodash/flatMap';
import uniq from 'lodash/uniq';
import { BetTypeGroup, MarketType } from '@/interface/enum';
import type { MainMarketConfig } from '@/libraries/marketTypeDisplayRule';

export const ePenaltyMainMarketConfig: MainMarketConfig[][] = [[
    { betTypeGroups: [BetTypeGroup.Main], marketType: MarketType.Handicap },
    { betTypeGroups: [BetTypeGroup.Main, BetTypeGroup.Soccer_PenaltyTenKick], marketType: MarketType.OverUnder },
]];

export const ePenaltyMainMarketBetTypeGroups = uniq(flatMap(ePenaltyMainMarketConfig).flatMap(x => x.betTypeGroups));

// Figma 18_Epenalty lists Full Time 1X2 above Odd/Even, unlike the shared `marketTypeDisplayOrder`.
export const ePenaltyMoreMarketDisplayOrder = [MarketType._1X2, MarketType.OddEven];
